import { X } from 'lucide-react';

interface ReaderMobileHeaderProps {
    title: string,
    onClose: () => void
}

const ReaderMobileHeader = ({ title, onClose }: ReaderMobileHeaderProps) => {
    return (
        <>
            <div className='flex justify-between items-center mt-2'>
                <h3 className='text-[18px] leading-[22px] font-black text-white'>{title}</h3>
                <button onClick={onClose} className='text-white'>
                    <X size={24} />
                </button>
            </div>
            <div className='h-[1px] w-full bg-[#FFFFFF1A] my-4' />
        </>
    );
};

export default ReaderMobileHeader;
